import { render, staticRenderFns } from "./change-agent-modal.vue?vue&type=template&id=4f8dbbba&"
import script from "./change-agent-modal.vue?vue&type=script&lang=js&"
export * from "./change-agent-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "change-agent-modal.vue"
export default component.exports